import { Link, useNavigate } from 'react-router-dom'
import { Button, Card, Form, Input, Typography, message } from 'antd'
import { useAuth } from '../hooks/useAuth'
import { productName } from '../branding'

const { Title, Paragraph } = Typography

export default function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const name = productName()

  return (
    <div style={{ maxWidth: 440, margin: '64px auto', padding: '0 16px' }}>
      <Card
        className="messenger-card"
        style={{
          background: '#ffffff',
          border: '1px solid #cbd5e1',
          boxShadow: '0 8px 30px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Title level={2} style={{ color: '#0f172a', marginTop: 0 }}>
          Log in
        </Title>
        <Paragraph style={{ color: '#475569' }}>Access your {name} dashboard.</Paragraph>
        <Form
          layout="vertical"
          onFinish={async (values) => {
            try {
              await login(values.email, values.password)
              navigate('/dashboard')
            } catch (e: unknown) {
              const err = e as { response?: { data?: { message?: string } }; message?: string }
              message.error(err.response?.data?.message || err.message || 'Login failed')
            }
          }}
        >
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input size="large" autoComplete="email" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password size="large" autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" size="large" block>
            Log in
          </Button>
        </Form>
        <Paragraph style={{ marginTop: 16, color: '#475569', marginBottom: 0 }}>
          New here? <Link to="/signup">Sign up for $20/mo</Link>
        </Paragraph>
      </Card>
    </div>
  )
}
